import React, { useState, useEffect } from "react";
import { Row, Col, Form } from "react-bootstrap";
import * as actions from "Store/Course/Instructor/OtherLabs/Actions";
import Options from "../Options";
import parse from "html-react-parser";
import "../../css/Numeric.scss";
import AnswerExplanation from "../../GradeSubmission/AnswerExplaination";
import { removeRemarks } from "../../GradeSubmission/GradeCheck";
import log from "loglevel";

function Numeric({ courseId, question, index, previousResponse, updateResponse, disable, Eval }) {
  const [responseId, setResponseId] = useState(null);
  const [saveResponseTimer, setSaveResponseTimer] = useState(null);
  const [userAnswer, setUserAnswer] = useState("");

  const mode = localStorage.getItem("mode");
  let minAnswerRange, maxAnswerRange, isAnswerCorrect = false, currentAnswer;

  const parseAnswerRange = (answerString) => {
    let minAnswerRange, maxAnswerRange;

    try {
      const rangeArray = JSON.parse(answerString.replace(/'/g, '"'));
      if (Array.isArray(rangeArray)) {
        minAnswerRange = parseFloat(rangeArray[0]);
        maxAnswerRange = parseFloat(rangeArray[1]);
      } else {
        // Handle case where it's a single value like "5.0"
        minAnswerRange = maxAnswerRange = parseFloat(rangeArray);
      }
    } catch (e) {
      // Fallback for cases where answerString is just a number or other invalid format
      minAnswerRange = maxAnswerRange = parseFloat(answerString);
    }
    return [minAnswerRange, maxAnswerRange];
  };

  if (question.questionanswer_set) {
    [minAnswerRange, maxAnswerRange] = parseAnswerRange(question.questionanswer_set[0]?.answer);
    log.log({ minAnswerRange, maxAnswerRange, question, previousResponse })

    if (previousResponse.response_text) {
      currentAnswer = parseFloat(previousResponse.response_text);
      if (currentAnswer >= minAnswerRange && currentAnswer <= maxAnswerRange) {
        isAnswerCorrect = true;
      }
    }
    log.log({ isAnswerCorrect, Eval })
  }

  useEffect(() => {
    if (previousResponse && responseId === null) {
      setResponseId(previousResponse.id);
    }
    if (previousResponse.response_text) {
      setUserAnswer(previousResponse.response_text);
    }
  }, [previousResponse, responseId]);

  const storeUserResponse = async (value) => {
    log.log({ courseId, question, responseId, value });
    const response = await actions.addQuestionResponsesRequest(
      courseId, question, null, value, responseId, null
    );
    if (response) {
      setResponseId(response.id);
      updateResponse({ ...response, id: question.id });
    }
  };

  const handleInputChange = (event) => {
    clearTimeout(saveResponseTimer);
    const { value } = event.target;
    setUserAnswer(value);
    const timerId = setTimeout(() => storeUserResponse(value), 1000);
    setSaveResponseTimer(timerId);
  };

  const saveScoredMarks = async (marks) => {
    await actions.addScoredMarksRequest(question, responseId, marks);
    updateResponse();
  };

  const renderQuestionText = () => {
    const sanitizedText = removeRemarks(question?.question_text);
    return <Col xs={12} className="question-text">{parse(sanitizedText)}</Col>;
  };

  const renderAnswerInput = () => {
    const borderStyle = Eval ? { border: isAnswerCorrect ? '2px solid green' : '2px solid red', backgroundColor: isAnswerCorrect ? '#b9eddd' : '' } : {};
    return (
      <Col xs={12} className={`option ${disable ? "disabled" : ""}`}>
        <Options
          questionId={question.id}
          options={question.questionoption_set}
          questionType={question.questionType}
          disable={disable}
          Eval={Eval}
        />
        <div style={borderStyle}>
          <Form.Control
            type="number"
            value={userAnswer}
            onChange={handleInputChange}
            disabled={disable}
          />
        </div>
      </Col>
    );
  };

  const getCorrectAnswerText = (questionanswer_set) => {
    if(!questionanswer_set || questionanswer_set.length==0) return "";
    return questionanswer_set.map(ans => String(ans['answer'])).join(', ');
  };

  const renderEvaluationSection = () => {
    if (!disable) return null;

    log.log({ isAnswerCorrect, Eval, mode, scored_marks: question?.questionresponse_set?.scored_marks })

    return (
      <>
        <Col xs={6}>

        </Col>
        <Col xs={6}>
          <Form.Check>
            <Form.Label>Scored Marks</Form.Label>
            <Form.Control
              type="number"
              min="0"
              value={question?.questionresponse_set?.scored_marks || 0}
              step="0.1"
              onBlur={(e) => saveScoredMarks(e.target.value)}
              disabled
            />
          </Form.Check>

          {(Eval || mode === "I") && (
            <div style={{ marginRight: '-100px', marginTop: '-40px', marginLeft: '-450px' }}>
              <AnswerExplanation explanation={question?.answer_explaination} correct_answer_text={getCorrectAnswerText(question?.questionanswer_set)} />
            </div>
          )}
        </Col>
      </>
    );
  };

  return (
    <div className="numeric-component" style={{ margin: 10 }}>
      <Row>
        <Col xs={12} style={{ marginBottom: 10 }}>
          <div className="question-header d-flex justify-content-between align-items-center">
            <b><i><span style={{ fontSize: 20, color: 'rgb(41, 121, 255)' }}>{`Question ${index + 1}`}</span></i></b>
            <span className="question-meta text-primary">
              <b><i>Question Type: {question.question_type === 'N' ? 'NAT' : ''} <span style={{ marginLeft: '40px' }}>Marks: {question.marks}</span></i></b>
            </span>
          </div>
        </Col>
        {renderQuestionText()}
        {renderAnswerInput()}
        {renderEvaluationSection()}
      </Row>
    </div>
  );
}

export default Numeric;
